import auth from '../../services/auth'

export default {

  data() {
    return {
      formState: 'NEW',
      loading: undefined,
      phone: undefined,
      errorMessage: undefined,
      successMessage:undefined
    }
  },

  computed: {},

  created(){},

  methods: {
    doRequest() {
      auth.saveHash(window.location.hash);
      this.formState = 'NEW';
      this.$validator.validateAll()
        .then(success => {
          let taxIdNumber = auth.getTaxIdNumber();
          auth.retrieveEmail(taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.phone).then(data => {
            if(data.status.code === 0) {
              this.formState = 'SUCCESS';
              this.successMessage = data.status.message;
            }
          }).catch(err => {
              this.formState = 'ERROR';
              this.errorMessage = err.data.status.message;
          });
        });
      },
  }
}


// WEBPACK FOOTER //
// ./src/pages/auth/auth-email-tel-req.js